module.exports = __webpack_public_path__ + "img/3-01-17-heaving-line.49c9db69.svg";